export default __webpack_public_path__ + "static/media/register-description-image.5e6e0c74.svg";